import React from 'react';
import styled from 'styled-components';
import androidTv from '../img/androidtv.png';
import IconBadge from './IconBadge';

const Badge: React.FC<React.PropsWithChildren<unknown>> = props => (
  <StyledIconBadge url={androidTv.src} {...props} />
);

const StyledIconBadge = styled(IconBadge)`
  width: 100px;
`;

export default Badge;
